import { ChevronRight, Check } from "lucide-react";
import { cn } from "~/lib/utils";

interface Props {
  currentIndex: number;
  steps: {
    title: string | null;
    description: string | null;
  }[];
}

export const OnboardingProgress = ({ currentIndex, steps }: Props) => {
  return (
    <div className="flex flex-wrap items-center justify-center gap-y-4">
      {steps.map((step, index) => {
        const isComplete = currentIndex > index;
        const isActive = currentIndex === index;

        return step.title ? (
          <div key={index} className="flex items-center">
            <div className="flex h-28 w-52 flex-col items-center gap-2">
              <div
                className={cn(
                  "flex size-10 shrink-0 items-center justify-center rounded-full",
                  {
                    "bg-success text-primary-foreground": isComplete,
                    "bg-info text-primary-foreground": !isComplete && isActive,
                    "bg-muted text-muted-foreground": !isComplete && !isActive,
                  },
                )}
              >
                {isComplete ? <Check className="size-5" /> : index + 1}
              </div>
              <div className="text-center text-sm">
                <div className="font-medium">{step.title}</div>
                <div className="text-muted-foreground text-xs">
                  {step.description}
                </div>
              </div>
            </div>
            {steps[index + 1]?.title && (
              <ChevronRight className="text-muted-foreground size-5" />
            )}
          </div>
        ) : null;
      })}
    </div>
  );
};
